module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://gluons.github.io/vue-github-buttons/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 24);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	'sync': {
		'path': 'M10.24 7.4a4.15 4.15 0 0 1-1.2 3.6 4.346 4.346 0 0 1-5.41.54L4.8 10.4.5 9.8l.6 4.2 1.31-1.26c2.36 1.74 5.7 1.57 7.84-.54a5.876 5.876 0 0 0 1.74-4.46l-1.75-.34zM2.96 5a4.346 4.346 0 0 1 5.41-.54L7.2 5.6l4.3.6-.6-4.2-1.31 1.26c-2.36-1.74-5.7-1.57-7.85.54C.5 5.03-.06 6.65.01 8.26l1.75.35A4.17 4.17 0 0 1 2.96 5z',
		'width': 12,
		'height': 16
	},
	'eye': {
		'path': 'M8.06 2C3 2 0 8 0 8s3 6 8.06 6C13 14 16 8 16 8s-3-6-7.94-6zM8 12c-2.2 0-4-1.78-4-4 0-2.2 1.8-4 4-4 2.22 0 4 1.8 4 4 0 2.22-1.78 4-4 4zm2-4c0 1.11-.89 2-2 2-1.11 0-2-.89-2-2 0-1.11.89-2 2-2 1.11 0 2 .89 2 2z',
		'width': 16,
		'height': 16
	},
	'star': {
		'path': 'M14 6l-4.9-.64L7 1 4.9 5.36 0 6l3.6 3.26L2.67 14 7 11.67 11.33 14l-.93-4.74z',
		'width': 14,
		'height': 16
	},
	'repoForked': {
		'path': 'M8 1a1.993 1.993 0 0 0-1 3.72V6L5 8 3 6V4.72A1.993 1.993 0 0 0 2 1a1.993 1.993 0 0 0-1 3.72V6.5l3 3v1.78A1.993 1.993 0 0 0 5 15a1.993 1.993 0 0 0 1-3.72V9.5l3-3V4.72A1.993 1.993 0 0 0 8 1zM2 4.2C1.34 4.2.8 3.65.8 3c0-.65.55-1.2 1.2-1.2.65 0 1.2.55 1.2 1.2 0 .65-.55 1.2-1.2 1.2zm3 10c-.66 0-1.2-.55-1.2-1.2 0-.65.55-1.2 1.2-1.2.65 0 1.2.55 1.2 1.2 0 .65-.55 1.2-1.2 1.2zm3-10c-.66 0-1.2-.55-1.2-1.2 0-.65.55-1.2 1.2-1.2.65 0 1.2.55 1.2 1.2 0 .65-.55 1.2-1.2 1.2z',
		'width': 10,
		'height': 16
	},
	'markGithub': {
		'path': 'M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z',
		'width': 16,
		'height': 16
	}
};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cacher = __webpack_require__(5);

function extractOcticonPath(pathTag) {
	// Use @Justineo's regex.
	return pathTag.match(/\bd="([^"]+)"/)[1];
}

function ghGet(path) {
	var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	var selector = function selector(fn) {
		var repoRegex = /^(\/repos\/)(.+)/;
		var userRegex = /^(\/users\/)(.+)/;
		if (repoRegex.test(path)) {
			return fn('repo', repoRegex);
		} else if (userRegex.test(path)) {
			return fn('user', userRegex);
		} else {
			return null;
		}
	};

	if (useCache) {
		var _resultPromise = selector(function (type, regex) {
			var cacher = new Cacher();
			var key = path.match(regex)[2];
			var data = type == 'repo' ? cacher.getRepo(key) : cacher.getUser(key);
			if (data) {
				return Promise.resolve(data);
			}
		});
		if (_resultPromise) {
			return _resultPromise; // Immediately return when cache found.
		}
	}

	/* global GH_ROOT_URL, GH_TOKEN */
	var requestUrl = "https://api.github.com" + path + "";

	var resultPromise = fetch(requestUrl, {
		method: 'GET',
		headers: {
			'Accept': 'application/vnd.github.v3+json'
		}
	}).then(function (res) {
		if (res.status == 200) {
			return res.json();
		} else {
			return Promise.reject(res.statusText);
		}
	});

	if (useCache) {
		return resultPromise.then(function (res) {
			selector(function (type, regex) {
				var cacher = new Cacher();
				var key = path.match(regex)[2];
				if (type == 'repo') {
					cacher.setRepo(key, res);
				} else {
					cacher.setUser(key, res);
				}
			});
			return res;
		});
	} else {
		return resultPromise;
	}
}

module.exports = {
	extractOcticonPath: extractOcticonPath,
	ghGet: ghGet
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(18),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\saran.tap\\my-projects\\vue-github-buttons\\src\\components\\Button.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Button.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a8bb3306", Component.options)
  } else {
    hotAPI.reload("data-v-a8bb3306", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _es6Promise = __webpack_require__(21);

var _es6Promise2 = _interopRequireDefault(_es6Promise);

var _Star = __webpack_require__(14);

var _Star2 = _interopRequireDefault(_Star);

var _Fork = __webpack_require__(13);

var _Fork2 = _interopRequireDefault(_Fork);

var _Watch = __webpack_require__(15);

var _Watch2 = _interopRequireDefault(_Watch);

var _Follow = __webpack_require__(12);

var _Follow2 = _interopRequireDefault(_Follow);

__webpack_require__(23);

__webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_es6Promise2.default.polyfill();

exports.default = {
	install: function install(Vue) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { useCache: true };

		if (options.useCache) {
			Vue.mixin({
				beforeCreate: function beforeCreate() {
					// Use `_vue-github-buttons_useCache` as parameter for injecting into components.
					this['_vue-github-buttons_useCache'] = true;
				}
			});
		}
		Vue.component('gh-btns-star', _Star2.default);
		Vue.component('gh-btns-fork', _Fork2.default);
		Vue.component('gh-btns-watch', _Watch2.default);
		Vue.component('gh-btns-follow', _Follow2.default);
	}
};
module.exports = exports['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Vue GitHub Buttons cacher.
 *
 * @class Cacher
 */
var Cacher = function () {
	_createClass(Cacher, null, [{
		key: 'hasSession',

		/**
   * Check session storage API support.
   *
   * @static
   * @returns {Boolean}
   *
   * @memberOf Cacher
   */
		value: function hasSession() {
			return window.sessionStorage ? true : false;
		}
		/**
   * Creates an instance of Cacher.
   *
   * @memberOf Cacher
   */

	}, {
		key: 'CACHE_NAME',

		/**
   * Cache name constant
   *
   * @readonly
   * @static
   *
   * @memberOf Cacher
   */
		get: function get() {
			return 'vue-github-buttons';
		}
	}]);

	function Cacher() {
		var autoCommit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

		_classCallCheck(this, Cacher);

		this.autoCommit = autoCommit;
		this.cache = {
			repo: {},
			user: {}
		};

		if (this.exist()) {
			this.retrieve();
		} else {
			this.commit();
		}
	}
	/**
  * Check cache existence in session storage.
  *
  * @returns {Boolean}
  *
  * @memberOf Cacher
  */


	_createClass(Cacher, [{
		key: 'exist',
		value: function exist() {
			if (Cacher.hasSession()) {
				var cache = sessionStorage.getItem(Cacher.CACHE_NAME);
				return cache ? true : false;
			}
			return false;
		}
		/**
   * Write cache data to session storage.
   *
   * @returns {Boolean} Commit result.
   *
   * @memberOf Cacher
   */

	}, {
		key: 'commit',
		value: function commit() {
			try {
				if (Cacher.hasSession()) {
					sessionStorage.setItem(Cacher.CACHE_NAME, JSON.stringify(this.cache));
				}
				return true;
			} catch (err) {
				return false;
			}
		}
		/**
   * Retrieve cache data from session storage.
   *
   *
   * @memberOf Cacher
   */

	}, {
		key: 'retrieve',
		value: function retrieve() {
			if (Cacher.hasSession()) {
				var cache = sessionStorage.getItem(Cacher.CACHE_NAME);
				if (cache) {
					this.cache = JSON.parse(cache);
				}
			}
		}
		/**
   * Clear cache.
   *
   *
   * @memberOf Cacher
   */

	}, {
		key: 'clear',
		value: function clear() {
			this.cache = {
				repo: {},
				user: {}
			};
			if (Cacher.hasSession()) {
				sessionStorage.removeItem(Cacher.CACHE_NAME);
			}
		}
		/**
   * Get repository data from cache.
   *
   * @param {String} slug GitHub slug.
   * @returns {Object}
   *
   * @memberOf Cacher
   */

	}, {
		key: 'getRepo',
		value: function getRepo(slug) {
			if (typeof slug === 'string' && this.cache.repo[slug]) {
				return this.cache.repo[slug];
			} else {
				return null;
			}
		}
		/**
   * Set repository data to cache.
   *
   * @param {String} slug GitHub slug.
   * @param {any} data Repository data.
   *
   * @memberOf Cacher
   */

	}, {
		key: 'setRepo',
		value: function setRepo(slug, data) {
			if (typeof slug === 'string' && data) {
				this.cache.repo[slug] = data;
				if (this.autoCommit) {
					this.commit();
				}
			}
		}
		/**
   * Get user data from cache.
   *
   * @param {String} username GitHub user's name.
   * @returns {Object}
   *
   * @memberOf Cacher
   */

	}, {
		key: 'getUser',
		value: function getUser(username) {
			if (typeof username === 'string' && this.cache.user[username]) {
				return this.cache.user[username];
			} else {
				return null;
			}
		}
		/**
   * Set user data to cache.
   *
   * @param {String} username GitHub user's name.
   * @param {Object} data User data.
   *
   * @memberOf Cacher
   */

	}, {
		key: 'setUser',
		value: function setUser(username, data) {
			if (typeof username === 'string' && data) {
				this.cache.user[username] = data;
				if (this.autoCommit) {
					this.commit();
				}
			}
		}
	}]);

	return Cacher;
}();

module.exports = Cacher;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _formatThousands = __webpack_require__(22);

var _formatThousands2 = _interopRequireDefault(_formatThousands);

var _resource = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var GH_URL = 'https://github.com';
var isset = function isset(value) {
	return typeof value !== 'undefined' && value != null && value != '';
};

exports.default = {
	name: 'gh-btns',
	props: {
		icon: {
			validator: function validator(value) {
				return isset(value.path) && isset(value.width) && isset(value.height);
			},

			required: true
		},
		isLoading: Boolean,
		count: Number,
		link: {
			type: String,
			required: true
		},
		countLink: String
	},
	filters: {
		formatNumber: function formatNumber(value) {
			if (typeof value !== 'undefined' && value != null) {
				return (0, _formatThousands2.default)(value, ',');
			} else {
				return value;
			}
		}
	},
	data: function data() {
		return {
			loadingIcon: _resource.sync
		};
	},

	computed: {
		hasCount: function hasCount() {
			var count = this.count;
			// Show count when count exist and greater than or equal to 0.
			return typeof count !== 'undefined' && count != null && count >= 0;
		},
		hasCountLink: function hasCountLink() {
			var countLink = this.countLink;
			return typeof countLink !== 'undefined' && countLink != null;
		},
		loadingBox: function loadingBox() {
			return '0 0 ' + this.loadingIcon.width + ' ' + this.loadingIcon.height;
		},
		box: function box() {
			return '0 0 ' + this.icon.width + ' ' + this.icon.height;
		},
		fullLink: function fullLink() {
			return GH_URL + '/' + this.link;
		},
		fullCountLink: function fullCountLink() {
			var countLink = this.countLink;
			if (typeof countLink !== 'undefined' && countLink != null) {
				return GH_URL + '/' + this.countLink;
			} else {
				return 'javascript:void(0);';
			}
		}
	}
};
module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Button = __webpack_require__(3);

var _Button2 = _interopRequireDefault(_Button);

var _resource = __webpack_require__(0);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'gh-btns-follow',
	components: {
		'gh-button': _Button2.default
	},
	data: function data() {
		return {
			icon: _resource.markGithub,
			count: null
		};
	},

	computed: {
		isLoading: function isLoading() {
			if (this.showCount) {
				return this.count == null;
			} else {
				return false;
			}
		}
	},
	props: {
		user: {
			type: String,
			required: true
		},
		showCount: Boolean
	},
	created: function created() {
		var _this = this;

		if (this.showCount) {
			var useCache = this['_vue-github-buttons_useCache'] ? true : false;
			(0, _utils.ghGet)('/users/' + this.user, useCache).then(function (res) {
				_this.count = parseInt(res['followers']);
			}, function () {
				_this.count = -1; // Don't show count when error.
			});
		}
	},
	updated: function updated() {
		var _this2 = this;

		if (this.showCount) {
			var useCache = this['_vue-github-buttons_useCache'] ? true : false;
			(0, _utils.ghGet)('/users/' + this.user, useCache).then(function (res) {
				_this2.count = parseInt(res['followers']);
			}, function () {
				_this2.count = -1; // Don't show count when error.
			});
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//

module.exports = exports['default'];

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Button = __webpack_require__(3);

var _Button2 = _interopRequireDefault(_Button);

var _resource = __webpack_require__(0);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'gh-btns-fork',
	components: {
		'gh-button': _Button2.default
	},
	data: function data() {
		return {
			icon: _resource.repoForked,
			count: null
		};
	},

	computed: {
		isLoading: function isLoading() {
			if (this.showCount) {
				return this.count == null;
			} else {
				return false;
			}
		}
	},
	props: {
		slug: {
			type: String,
			required: true
		},
		showCount: Boolean
	},
	created: function created() {
		var _this = this;

		if (this.showCount) {
			var useCache = this['_vue-github-buttons_useCache'] ? true : false;
			(0, _utils.ghGet)('/repos/' + this.slug, useCache).then(function (res) {
				_this.count = parseInt(res['forks_count']);
			}, function () {
				_this.count = -1; // Don't show count when error.
			});
		}
	},
	updated: function updated() {
		var _this2 = this;

		if (this.showCount) {
			var useCache = this['_vue-github-buttons_useCache'] ? true : false;
			(0, _utils.ghGet)('/repos/' + this.slug, useCache).then(function (res) {
				_this2.count = parseInt(res['forks_count']);
			}, function () {
				_this2.count = -1; // Don't show count when error.
			});
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//

module.exports = exports['default'];

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Button = __webpack_require__(3);

var _Button2 = _interopRequireDefault(_Button);

var _resource = __webpack_require__(0);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'gh-btns-star',
	components: {
		'gh-button': _Button2.default
	},
	data: function data() {
		return {
			icon: _resource.star,
			count: null
		};
	},

	computed: {
		isLoading: function isLoading() {
			if (this.showCount) {
				return this.count == null;
			} else {
				return false;
			}
		}
	},
	props: {
		slug: {
			type: String,
			required: true
		},
		showCount: Boolean
	},
	created: function created() {
		var _this = this;

		if (this.showCount) {
			var useCache = this['_vue-github-buttons_useCache'] ? true : false;
			(0, _utils.ghGet)('/repos/' + this.slug, useCache).then(function (res) {
				_this.count = parseInt(res['stargazers_count']);
			}, function () {
				_this.count = -1; // Don't show count when error.
			});
		}
	},
	updated: function updated() {
		var _this2 = this;

		if (this.showCount) {
			var useCache = this['_vue-github-buttons_useCache'] ? true : false;
			(0, _utils.ghGet)('/repos/' + this.slug, useCache).then(function (res) {
				_this2.count = parseInt(res['stargazers_count']);
			}, function () {
				_this2.count = -1; // Don't show count when error.
			});
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//

module.exports = exports['default'];

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Button = __webpack_require__(3);

var _Button2 = _interopRequireDefault(_Button);

var _resource = __webpack_require__(0);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'gh-btns-watch',
	components: {
		'gh-button': _Button2.default
	},
	data: function data() {
		return {
			icon: _resource.eye,
			count: null
		};
	},

	computed: {
		isLoading: function isLoading() {
			if (this.showCount) {
				return this.count == null;
			} else {
				return false;
			}
		}
	},
	props: {
		slug: {
			type: String,
			required: true
		},
		showCount: Boolean
	},
	created: function created() {
		var _this = this;

		if (this.showCount) {
			var useCache = this['_vue-github-buttons_useCache'] ? true : false;
			(0, _utils.ghGet)('/repos/' + this.slug, useCache).then(function (res) {
				_this.count = parseInt(res['subscribers_count']);
			}, function () {
				_this.count = -1; // Don't show count when error.
			});
		}
	},
	updated: function updated() {
		var _this2 = this;

		if (this.showCount) {
			var useCache = this['_vue-github-buttons_useCache'] ? true : false;
			(0, _utils.ghGet)('/repos/' + this.slug, useCache).then(function (res) {
				_this2.count = parseInt(res['subscribers_count']);
			}, function () {
				_this2.count = -1; // Don't show count when error.
			});
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//

module.exports = exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(16),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\saran.tap\\my-projects\\vue-github-buttons\\src\\components\\Follow.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Follow.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1d71237c", Component.options)
  } else {
    hotAPI.reload("data-v-1d71237c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(19),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\saran.tap\\my-projects\\vue-github-buttons\\src\\components\\Fork.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Fork.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d74a5666", Component.options)
  } else {
    hotAPI.reload("data-v-d74a5666", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(17),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\saran.tap\\my-projects\\vue-github-buttons\\src\\components\\Star.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Star.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72acf346", Component.options)
  } else {
    hotAPI.reload("data-v-72acf346", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(20),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\saran.tap\\my-projects\\vue-github-buttons\\src\\components\\Watch.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Watch.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ff1e0058", Component.options)
  } else {
    hotAPI.reload("data-v-ff1e0058", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gh-button', {
    attrs: {
      "icon": _vm.icon,
      "is-loading": _vm.isLoading,
      "link": _vm.user,
      "count": _vm.count,
      "count-link": (_vm.user + "/followers")
    }
  }, [_vm._v("\n\tFollow\n")])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d71237c", module.exports)
  }
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gh-button', {
    attrs: {
      "icon": _vm.icon,
      "is-loading": _vm.isLoading,
      "link": _vm.slug,
      "count": _vm.count,
      "count-link": (_vm.slug + "/stargazers")
    }
  }, [_vm._v("\n\tStar\n")])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72acf346", module.exports)
  }
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gh-button-container"
  }, [(!_vm.isLoading) ? [_c('a', {
    staticClass: "gh-button",
    class: {
      'with-count': _vm.hasCount
    },
    attrs: {
      "href": _vm.fullLink,
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "octicon",
    attrs: {
      "width": _vm.icon.width,
      "height": _vm.icon.height,
      "viewBox": _vm.box
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.icon.path
    }
  })]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.hasCount) ? _c('a', {
    staticClass: "social-count",
    attrs: {
      "href": _vm.fullCountLink,
      "target": _vm.hasCountLink ? '_blank' : null
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.count)) + "\n\t\t")]) : _vm._e()] : [_c('a', {
    staticClass: "gh-button"
  }, [_c('svg', {
    staticClass: "octicon spin",
    attrs: {
      "width": _vm.loadingIcon.width,
      "height": _vm.loadingIcon.height,
      "viewBox": _vm.loadingBox
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.loadingIcon.path
    }
  })])])]], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a8bb3306", module.exports)
  }
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gh-button', {
    attrs: {
      "icon": _vm.icon,
      "is-loading": _vm.isLoading,
      "link": (_vm.slug + "/fork"),
      "count": _vm.count,
      "count-link": (_vm.slug + "/network")
    }
  }, [_vm._v("\n\tFork\n")])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d74a5666", module.exports)
  }
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gh-button', {
    attrs: {
      "icon": _vm.icon,
      "is-loading": _vm.isLoading,
      "link": (_vm.slug + "/subscription"),
      "count": _vm.count,
      "count-link": (_vm.slug + "/watchers")
    }
  }, [_vm._v("\n\tWatch\n")])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ff1e0058", module.exports)
  }
}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = require("es6-promise");

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = require("format-thousands");

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = require("unfetch/polyfill");

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./~/vue-github-buttons/dist/vue-github-buttons.js
// module id = hEsw
// module chunks = 10